import React, { useRef } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { SectionHeader, SimpleProfileCard } from "../../molecules";
import { CallToAction, Container, EntryAnimation } from "../../atoms";
export default function SimpleProfileCardsGridSection(param) {
    var title = param.title, subtitle = param.subtitle, cards = param.cards, action = param.action, className = param.className;
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: SimpleProfileCardsGridSection.name,
        className: className
    }, !!(title || subtitle) && /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "text-center mb-7 md:mb-8"
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("grid grid-flow-row auto-rows-max gap-6", "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4")
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(card.title),
            delay: cardIndex % 3 / 10
        }, /*#__PURE__*/ React.createElement(SimpleProfileCard, card));
    })), !!action && /*#__PURE__*/ React.createElement("div", {
        className: "flex mt-6 justify-center"
    }, /*#__PURE__*/ React.createElement(CallToAction, action)));
}

//# sourceMappingURL=SimpleProfileCardsGridSection.js.map